import { COLORS } from '@shared/config/colors/colors';
import { baseShadowStyle } from '@shared/style/base-shadow';
import { LinkScroll } from '@shared/ui/link-scroll/link-scroll';
import { Typography } from '@shared/ui/typography/typography';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    padding: 20px;
    justify-content: space-between;
    gap: 16px;
    border-radius: 20px;
    background-color: ${COLORS.neutral_00};
    ${baseShadowStyle}
`;

export const Avatar = styled('div')`
    display: flex;
    align-items: center;
`;

export const AvatarContainer = styled('div')`
    position: relative;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: ${COLORS.grey};

    > div {
        width: 100% !important;
        height: 100% !important;
    }
`;

export const Content = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-grow: 1;
`;

export const Controls = styled('div')`
    display: flex;
    align-items: flex-start;
`;

export const Name = styled(Typography)`
    margin-bottom: 4px;
`;

export const Role = styled(Typography)``;

export const StyledLink = styled(LinkScroll)`
    color: ${COLORS.neutral_50};
`;

export const AvatarWrapper = styled('div')`
    position: relative;
    display: flex;
`;
